import React, { useState, useRef } from "react";
import { Button, Upload, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import UploadIcon from "../../image/uploadadd.svg";
import Trash from "../../image/trash.svg";
import PreView from "../../image/big.svg";
import { uploadSoftInfo, getOssObj } from "../../service/register";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { message } from "../../components/Message";

import axios from "axios";

import styles from "./index.module.less";

// 封装获取 cookie 的方法
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
}

const CustomUpload = ({
  maxCount,
  tips,
  value,
  onChange,
  fileList,
  form,
  name,
  softForm,
  accept
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  function customRequest(option) {
    // const reader = new FileReader();
    // reader.readAsDataURL(option.file);
    // reader.onloadend = function(e) {
    //   console.log(e.target.result); // 打印图片的base64
    //   if (e && e.target && e.target.result) {

    //   }
    // };
    console.log("option is", option);
    dispatch.oss.setOssAsync({
      app_file_name: option?.file?.name,
      size: option?.file?.size,
      id: Number(id),
      app_id: softForm.app_id,
      app_version: softForm.app_version,
    }).then((res) => {
      console.log("res is", res)
      const uploadUlr = res?.upload_url;
      const formData = new FormData();
      formData.append("file", option.file);
      const config = {
        headers: {
          // "content-type": "multipart/form-data",
          "x-csrf-token": getCookie("csrfToken"),
        },
        withCredentials: false
      };
      console.log("uploadUlr is", uploadUlr);
      const url = uploadUlr.replace(
        "https://shanghai.xstore.qihu.com",
        ""
      );
      // debugger
      // axios
      //   .put(url, {

      //   }, config)
      //   .then((res) => {
      //     option.onSuccess(res.data, option.file);
      //   })
      //   .catch((err) => {
      //     
      //     console.log(err);
      //   });

      fetch(uploadUlr, {
        method: "PUT",
        body: option?.file,
        headers: {
          "content-type": "multipart/form-data",
          "x-csrf-token": getCookie("csrfToken"),
        },
        mode: "cors",
      }).then((res) => {
        if (res.status == 200) {
          option.onSuccess(res.data, option.file);
        }
        console.log("res is", res);
      });
    });
  }

  const [preview, setPreview] = useState({
    isOpen: false,
    seeImage: "",
    setTitle: "",
  });

  const [upFileList, setUpFilelist] = useState([]);

  const CustomItemRender = (originNode, file, fileList, actions) => {
    return (
      <div className="custom-item-renderer">
        {/* <img src={file.thumbUrl} alt={file.name} /> */}
        <div className="buttons flex mt-1 ">
          {/* <Button size="small" onClick={() => handlePreview(fileList)}>
            View
          </Button>
          <Button size="small" onClick={() => onRemove(fileList)}>
            Delete
          </Button> */}
          <div className="mask-r">
            <div
              onClick={() =>
                actions.preview(
                  setPreview({
                    isOpen: true,
                    seeImage: file.thumbUrl,
                    setTitle: file.name,
                  })
                )
              }
            >
              <PreView
                className="mask-icon preview"
                width="15"
                height="15"
              ></PreView>
            </div>
            <div onClick={() => actions.remove(fileList)}>
              <Trash className="mask-icon" width="15" height="15"></Trash>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleBeforeUpload = (file, fileList) => {
    console.log("s3ipload is ",file)
    const isValidType = file.name.indexOf('exe') > -1 || file.name.indexOf('msi') > -1 || file.name.indexOf('zip') > -1
    const isGt500M = file.size / 1024 / 1024 > 500;
    if (!isValidType) {
      message.show({
        type: "error",
        content: "上传类型为 exe/msi/zip",
      });
    }
    if (isGt500M) {
      // console.error("exe must smaller than 500MB!");
      message.show({
        type: 'error',
        content: '超过500m'
      })
    }
    return (isValidType && !isGt500M) || Upload.LIST_IGNORE;
  };

  const handleOnChange = (info) => {
    // 通过status判断文件已上传成功
    let newFileList = [...info.fileList];
    newFileList = newFileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });
    form.setFieldsValue({
      [name]: newFileList,
    });
  };
  console.log("fileList is", fileList);
  return (
    <>
      <Upload
        className="customs3_upload"
        onChange={handleOnChange}
        // itemRender={CustomItemRender}
        customRequest={customRequest}
        beforeUpload={handleBeforeUpload}
        listType="text"
        fileList={fileList}
        accept={accept}
        // action="http://127.0.0.1:3333/api/system/protocol/upload"
      >
        {fileList?.length >= maxCount ? null : (
          <div className={styles.uploadCt}>
            <div className={styles.UploadIcon}>
              <UploadIcon></UploadIcon>
            </div>
            <div className={styles.uploadText}>点击添加文件</div>
          </div>
        )}
      </Upload>
      <div className={styles.uploadTips}>{tips}</div>
      <Modal
        open={preview.isOpen}
        title={preview.setTitle}
        footer={null}
        onCancel={() =>
          setPreview({ isOpen: false, seeImage: "", setTitle: "" })
        }
      >
        <img style={{ width: "100%" }} src={preview.seeImage} alt="example" />
      </Modal>
    </>
  );
};

export default CustomUpload;
